<template>
  <div class="led">
    <div class="info">
      <div
        :style="{
          backgroundImage: `url(${user.avatar || images.avatar})`,
        }"
        class="avatar"
        @click="onUserClick"
      ></div>
      <div class="nickname" @click="onUserClick">
        {{ user.nickname }}
      </div>
      <template v-if="keyframes.length">
        <c-led-strip-65-game-boy
          class="leds"
          :isPlaying="true"
          :speed="speed"
          :frames="frames"
        />
        <c-led-pcb-65-game-boy
          class="lights"
          :isPlaying="true"
          :speed="speed"
          :frames="keyframes"
        />
      </template>
      <c-led-canvas v-else class="led-canvas" :frames="frames" :speed="speed" />
      <div class="info">
        <div class="name">
          {{ led.name }}
        </div>
        <div class="description">
          {{ led.description }}
        </div>
        <div class="icons">
          <div
            class="icon"
            :class="{
              active: led.is_like,
            }"
            @click="onLike"
          >
            <c-like class="like" :liked="led.is_like" />
            {{ led.like_count || "" }}
          </div>
          <div class="icon" @click="toComment">
            <i class="download iconfont iconhuabantaolun" />
            {{ led.comment_count || "" }}
          </div>
          <c-profile-turn class="icon" :content="content" type="download">
            <i class="iconfont icondownload-b" />
          </c-profile-turn>
          <c-profile-turn class="icon" :content="content" type="turn">
            <i class="download iconfont iconrefresh" />
          </c-profile-turn>
          <c-share>
            <div class="icon">
              <i class="download iconfont iconfenxiang" />
            </div>
          </c-share>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="comments">
      <md-field class="textarea">
        <label>{{ $t("addComment") }}</label>
        <md-textarea
          ref="comment"
          v-model="comment"
          maxlength="200"
        ></md-textarea>
      </md-field>
      <div class="buttons">
        <md-button class="cancel" @click="onCommentCancel">{{
          $t("cancel")
        }}</md-button>
        <md-button
          class="submit"
          @click="onComment"
          :disabled="!comment.trim()"
          >{{ $t("submit") }}</md-button
        >
      </div>
      <c-comment
        class="comment"
        v-for="item in commentList"
        :key="item.id"
        :led="led"
        :comment="item"
        @reply="led.comment_count += 1"
      />
      <md-button
        v-if="commentList.length !== count"
        class="more"
        @click="onShowMore"
        >{{ $t("showMore") }}</md-button
      >
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepCopy } from "@/utils";
import api from "@/api";
export default {
  name: "LED",
  data() {
    return {
      user: {},
      led: {},
      comment: "",
      commentList: [],
      page: 1,
      count: 0,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("profile", {
      default: "default",
    }),
    ...mapState("user", {
      isSignIn: "isSignIn",
      userId: "id",
    }),
    isOwner() {
      return !(this.userId && this.userId !== this.led.user_id);
    },
    content() {
      try {
        const content = JSON.parse(this.led.config_text);
        console.log(content);
        return content;
      } catch {
        return null;
      }
    },
    frames() {
      return this.content ? this.content.frames.frame_data : [];
    },
    keyframes() {
      return this.content ? this.content.keyframes.frame_data : [];
    },
    speed() {
      return this.content ? this.content.speed_ms : 0;
    },
    data() {
      let lightEffects = deepCopy(this.default.lightEffects);
      lightEffects[4] = this.content;
      return {
        ...this.default,
        lightEffects,
      };
    },
  },
  methods: {
    getLED() {
      const id = Number(this.$route.params.id);
      this.$store.dispatch("led/getLED", id).then((res) => {
        this.led = res;
        this.loading = false;
        api.getUser(this.led.user_uuid).then((res) => {
          this.user = res;
        });
        this.getCommentList();
      });
    },
    getCommentList(page = 1) {
      api
        .getCommentList({
          content_type: "diy_led",
          object_id: this.led.id,
          superior_id: "",
          page_number: page,
          page_size: 5,
          ordering: "-id",
        })
        .then((res) => {
          res.results = res.results || [];
          this.commentList =
            page === 1 ? res.results : [...this.commentList, ...res.results];
          this.page = page;
          this.count = res.count;
        });
    },
    onLike() {
      if (!this.isSignIn) {
        this.$store.dispatch("user/signIn");
      } else {
        if (this.led.is_like) {
          api.unlikeLED(this.led.id).then((res) => {
            this.led.like_count = res.count;
            this.led.is_like = false;
          });
        } else {
          api.likeLED(this.led.id).then((res) => {
            this.led.like_count = res.count;
            this.led.is_like = true;
          });
        }
      }
    },
    toComment() {
      if (this.isSignIn) {
        this.$refs.comment.$el.focus();
      } else {
        this.$store.dispatch("user/signIn");
      }
    },
    onComment() {
      if (this.isSignIn) {
        api
          .addComment({
            content_type: "diy_led",
            object_id: this.led.id,
            content: this.comment.trim(),
          })
          .then(() => {
            this.comment = "";
            this.led.comment_count += 1;
            this.getCommentList();
          });
      } else {
        this.$store.dispatch("user/signIn");
      }
    },
    onCommentCancel() {
      this.comment = "";
    },
    onShowMore() {
      this.getCommentList(this.page + 1);
    },
    onUserClick() {
      this.$router.push({
        path: this.$paths.user.replace(":uuid", this.led.user_uuid),
      });
    },
  },
  mounted() {
    this.getLED();
  },
  watch: {
    ["$route.params.id"]() {
      this.getLED();
    },
  },
};
</script>
<style lang="scss" scoped>
.led {
  min-height: inherit;
  padding: 50px 80px;

  .info {
    width: 1040px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: relative;

    .avatar {
      width: 75px;
      height: 75px;
      border-radius: 50%;
      background: $primary-color no-repeat center / cover;
      margin-right: 20px;
      cursor: pointer;
    }

    .nickname {
      width: 50%;
      font-size: 20px;
      font-weight: bold;
      color: #ffffff;
      flex: auto;
      cursor: pointer;
    }

    .leds {
      z-index: 1;
      margin: 0;
      top: 75px;
      position: absolute;
    }

    .lights {
      z-index: 0;
    }

    .led-canvas {
      width: 1040px;
      height: 130px;
      border-bottom: 2px solid $primary-color;
      margin-top: 30px;
    }

    .name {
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;
      line-height: 48px;
      min-height: 48px;
      margin-top: 10px;
    }

    .description {
      width: 100%;
      font-size: 12px;
      color: #ffffff;
      line-height: 26px;
      min-height: 26px;
    }

    .icons {
      width: 100%;
      margin-top: 10px;
      @include flex-center;

      .icon {
        @include flex-center;
        color: #ffffff;
        font-size: 16px;
        cursor: pointer;
        margin-left: 30px;

        &:hover,
        &.active {
          color: $primary-color;
        }
        &.disabled {
          color: #ffffff;
          cursor: not-allowed;
        }

        i,
        .like {
          font-size: 30px;
          margin-right: 5px;
        }
      }
    }
  }

  .line {
    width: 100%;
    height: 1px;
    background: #e7e7e7;
    opacity: 0.3;
    margin-top: 20px;
  }

  .comments {
    width: 740px;
    margin: 0 auto;

    .textarea {
      margin: 30px 0 10px 0;

      label {
        background: #171717;
      }

      textarea {
        min-height: 70px;
      }
    }

    .buttons {
      @include flex-center;
      justify-content: flex-end;

      .submit {
        margin-right: 0;
        background-color: $primary-color;
      }
    }

    .comment {
      margin-top: 50px;
    }

    .more {
      width: 150px;
      display: block;
      margin: 0 auto;
      color: $primary-color;
      font-size: 14px;
      text-align: center;
      padding: 10px 0;
      margin-top: 10px;
      cursor: pointer;
    }
  }
}
</style>
